import React, { useEffect, useState } from 'react'
import ScratchCard, { CUSTOM_BRUSH_PRESET } from "react-scratchcard-v2";
import styles from './scratch-game.module.css';
import BallsGameInstruction from '../balls-game-instruction/BallsGameInstruction';
import BallsGamePasscode from '../balls-game-passcode/BallsGamePasscode';
import WinPriceModal from '../win-price-modal/WinPriceModal';
import { useSelector } from 'react-redux';
import { axios_updateVoucherStatus } from '../../apiConnections/voucherApi';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

export default function ScratchGame() {
    const { voucher_id } = useParams();
    const gameData = useSelector((state) => state?.game?.gameData)

    // const ref = React.createRef();
    const [currentStep, setCurrentStep] = useState("instruction") //instruction, passcode, game
    const [isBackgroundAudioPlaying, setIsBackgroundAudioPlaying] = useState(false);
    const [scratchCardSize, setScratchCardSize] = useState(120)
    const [score, setScore] = useState(1)
    const [isWinPriceModalOpen, setIsWinPriceModalOpen] = useState(false)
    const [glowingCardNumber, setGlowingCardNumber] = useState(0);
    const [glowingCardNumber2, setGlowingCardNumber2] = useState(0);
    const [scratchCardMessage, setScratchCardMessage] = useState([
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false },
        { message: "Try Again!", isScratch: false }
    ]);
    const [errorMessage, setErrorMessage] = useState("")

    //All audio here
    const audio = new Audio('../sound/magical-surprise.mp3');
    const ScratchGameWin = new Audio('../sound/ball-game-win.mp3');

    useEffect(() => {
        setErrorMessage("")
    }, [])



    //background sound functionalities
    useEffect(() => {
        const backgroundAudio = new Audio('../sound/scratch-game-background.mp3');

        if (isBackgroundAudioPlaying) {
            backgroundAudio.play()
            backgroundAudio.volume = 0.6;
            backgroundAudio.loop = true;
        } else {
            backgroundAudio.pause();
        }

        return () => {
            backgroundAudio.pause();
            backgroundAudio.currentTime = 0;
        }
    }, [isBackgroundAudioPlaying]);

    //random number for glowing card functionality
    useEffect(() => {
        if (score <= gameData?.game?.win_count) {
            const intervalId = setInterval(() => {
                let newRandomNumber;
                do {
                    newRandomNumber = Math.floor(Math.random() * 9);
                } while (newRandomNumber === glowingCardNumber);

                setGlowingCardNumber(newRandomNumber);
            }, 1900);

            const intervalId2 = setInterval(() => {
                let newRandomNumber2;
                do {
                    newRandomNumber2 = Math.floor(Math.random() * 9);
                } while (newRandomNumber2 === glowingCardNumber2);

                setGlowingCardNumber2(newRandomNumber2);

            }, 1100);


            return () => {
                clearInterval(intervalId);
                clearInterval(intervalId2)
            };
        } else {
            // Clear the interval if score is equal to or greater than win_count
            setGlowingCardNumber(5);
            setGlowingCardNumber2(5);
        }
    }, [score, gameData?.game?.win_count, glowingCardNumber]);
    //glowing card end

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) { // for mobile devices
                setScratchCardSize(90);
            } else { // for desktop devices
                setScratchCardSize(160);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const scratchComplete = (index) => {
        audio.play();
        setScore(score + 1)

        const updatedScratchCardMessage = [...scratchCardMessage];
        updatedScratchCardMessage[index].isScratch = true;
        setScratchCardMessage(updatedScratchCardMessage);

        // if(score < gameData?.game?.win_count){
        //     setErrorMessage(`Oops try again! You have ${gameData?.game?.win_count-score} more changes to win.`);
        // toast.dismiss();
        // toast.error(`Oops try again! You have ${gameData?.game?.win_count-score} more changes to win.`, {
        //     position: toast.POSITION.BOTTOM_CENTER,
        //     limit: 1
        // });           
        // }
    }


    useEffect(() => {
        //update You won message on the last chance
        if (score === gameData?.game?.win_count) {
            setScratchCardMessage(prevMessages => {
                return prevMessages.map(message => {
                    if (!message.isScratch) {
                        return { ...message, message: "You Won🎉" }
                    }
                    return message;
                });
            });
        }
        //game won functionality
        if (score > gameData?.game?.win_count) {
            ScratchGameWin.play()
            setTimeout(() => {
                //remove full screen
                setIsWinPriceModalOpen(true)
                // if (document.exitFullscreen) {
                //     document.exitFullscreen();
                // } else if (document.webkitExitFullscreen) {
                //     document.webkitExitFullscreen();
                // } else if (document.mozCancelFullScreen) {
                //     document.mozCancelFullScreen();
                // } else if (document.msExitFullscreen) {
                //     document.msExitFullscreen();
                // }
            }, 500);
            //update step status
            const updateStatusReq = {
                voucher_id: voucher_id,
                status: 3 // game won
            }
            axios_updateVoucherStatus(updateStatusReq)
        }
    }, [score])

    useEffect(() => {
        if (score === 2) {
            setErrorMessage("You're not done yet - 🎯 two more opportunities to claim the prize🎈!")
        } else if (score === 3) {
            setErrorMessage("Stay determined - one more attempt to conquer! 💥🃏")
        } else {
            setErrorMessage("")
        }
    }, [score])


    return (
        <>
            <div className={`${styles.scratch_game_container} container-fluid`} style={{
                position: currentStep === "game" ? 'fixed' : 'relative'
            }}>

                <div className='position-absolute end-0 pt-2 pe-2'>
                    <div className='sound-play-pause'>
                        <button className='btn btn-dark d-flex' onClick={() => setIsBackgroundAudioPlaying(!isBackgroundAudioPlaying)}>
                            {isBackgroundAudioPlaying ? "⏸️" : "▶️"}
                            <span className='d-none d-sm-block'>{isBackgroundAudioPlaying ? "Pause 🎶" : "Play 🎶"}</span>
                        </button>
                    </div>
                </div>


                <div>

                    {/* <button onClick={onClickReset}>Reset</button> */}
                    {currentStep === "game" &&
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ minHeight: '100vh' }}>
                            <div className="row">
                                <div className="col-12 text-light pt-3 pb-2 text-center">
                                    <h2 className='fw-bolder'>{gameData?.game?.name}</h2>
                                    <p>{gameData?.game?.desc}</p>
                                </div>
                                <div className="col-12 col-lg-6 offset-lg-3">

                                    <div className='mb-4 mb-lg-0'>
                                        <div style={{ height: '60px' }}>
                                            {errorMessage &&
                                                <div className='text-warning text-center mb-5 py-2 rounded' style={{ backgroundColor: '#00000041' }}>
                                                    {errorMessage}
                                                </div>
                                            }
                                        </div>
                                    </div>


                                    <div className="row">
                                        {scratchCardMessage.map((item, index) => (
                                            <div className="col-4 mb-1 d-flex justify-content-center">
                                                <div className='p-2 bg-warning rounded shadow-lg'>
                                                    <div className={`${styles.scratch_card_wrapper} ${index === glowingCardNumber && styles.glowing_card_animation} ${index === glowingCardNumber2 && styles.glowing_card_animation}`} >
                                                        <div className=''>
                                                            <ScratchCard
                                                                // ref={ref}
                                                                width={scratchCardSize}
                                                                height={scratchCardSize}
                                                                image={'../images/start.png'}
                                                                finishPercent={45}
                                                                // brushSize={25}
                                                                onComplete={() => scratchComplete(index)}
                                                            >
                                                                <div style={{
                                                                    display: 'flex',
                                                                    // width: '100%',
                                                                    height: '100%',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    backgroundColor: '#ffc107'
                                                                }}
                                                                >
                                                                    <div className='text-center'>
                                                                        {item.isScratch ?
                                                                            <p className='mb-0 fw-bold fs-3'>{item.message}</p>
                                                                            :
                                                                            <p className='mb-0 fw-bold fs-6'>Scratch & Win</p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </ScratchCard>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}


                                    </div>
                                </div>
                            </div>
                        </div>
                    }


                    {currentStep === "instruction" &&
                        <div className='text-center'>
                            <BallsGameInstruction setCurrentStep={setCurrentStep} setIsBackgroundAudioPlaying={setIsBackgroundAudioPlaying} />
                        </div>
                    }

                    {currentStep === "passcode" &&
                        <div className='text-center'>
                            <BallsGamePasscode setCurrentStep={setCurrentStep} />
                        </div>
                    }

                </div>



            </div>


            <WinPriceModal isOpen={isWinPriceModalOpen} setIsOpen={setIsWinPriceModalOpen} prizeMessage={gameData?.game?.win_msg} />


        </>
    )
}
